import { removeCount } from "utils/removeCountFromTitle";

import { mBinSize } from "./binSize";
import { PropertyFilterModel } from "./filter";
import { INormalizeBySetting } from "./index";
import { PdenSourceEnum } from "./pdenDataSourceSetting";
import { ForecastTrumpParamsType } from "./schemas/data.schema";

export class LegendItemModel {
  text: string;
  count: number;
  color: string;
  title: string;
  value: string;
  fontColor: string;
  property: string;
  canBin: boolean;
  isChecked: boolean;
  isNotEqual: boolean;
  groupTitle?: string;
  categoryId: string;
  inFilter: boolean;
  bin: mBinSize;
  normalizeBySettings: INormalizeBySetting;
  isColorLocked: boolean;
  paletteColor: string;
  groupByTitle: string;
  partialContextTitle: string;
  isForecastToggleOn: boolean;
  selectedForecastFolderName: string;
  forecastTrumpingSettings?: ForecastTrumpParamsType;
  performanceDateRange?: { startDate: string; endDate: string };
  pdenSource: PdenSourceEnum;
  isScreenShot: boolean;
  disabled: boolean;
  // The "N Others" row, which stands for every value the bins folded away.
  isOthersRollup: boolean;
  id: string;
  lineStyle?: string | number[];
  // Written back verbatim by the checked set instead of being rebuilt from this item.
  retainedFilter?: PropertyFilterModel;
  constructor(
    title,
    property?,
    canBin?,
    categoryId?,
    bin?,
    inFilter?,
    count?,
    normalizeBySettings?,
    groupByTitle?,
    partialContextTitle?,
    isForecastToggleOn?,
    selectedForecastFolderName?,
    pdenSource?: PdenSourceEnum
  ) {
    this.text = title;
    this.count = count;
    this.value = removeCount(title);
    this.title = title;
    this.property = property;
    this.color = "";
    this.fontColor = "";
    this.canBin = canBin;
    this.isChecked = false;
    this.isNotEqual = false;
    this.categoryId = categoryId;
    this.inFilter = inFilter;
    this.bin = bin;
    this.normalizeBySettings = normalizeBySettings;
    this.isColorLocked = false;
    this.paletteColor = "";
    this.groupByTitle = "";
    this.partialContextTitle = "";
    this.isForecastToggleOn = false;
    this.selectedForecastFolderName = "";
    this.pdenSource = pdenSource ?? PdenSourceEnum.Public;
  }
}

export interface FocusTreeMapInputModel {
  items: LegendItemModel[];
  onChange: (legendItems: LegendItemModel[]) => void;
}
